import isBrowser from '@/utils/is-browser.js'

export default function () {
  return isBrowser ? window.APP_NAME : ':appName'
}
